export default __webpack_public_path__ + "static/media/holyaccession.93cb09b0.png";